import { ITravelInformation } from '.';
import { TicketType } from '../../models/ticket-type.enum';

export const defaultTravelInformation: ITravelInformation = {
  travelDaysPerMonth: undefined,
  distanceFromHomeToWorkKmState: undefined,
  prefferredTicketType: TicketType.ThirtyDays,
  travelZones: [],
};
